import { _ as _sliced_to_array } from "@swc/helpers/_/_sliced_to_array";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Core } from "@faire/design-tokens";
import { getSpacing } from "@faire/web--source/slate/spacing";
import { useViewport } from "@faire/web--source/ui/hooks/useViewport";
import React, { useState } from "react";
import styled, { css } from "styled-components";
import { AppsFlyerQRCode } from "@faire/retailer-visitor-shared/icons/AppsFlyerQRCode/AppsFlyerQRCode";
export var MobileBadge = function(param) {
    var backgroundColor = param.backgroundColor, badge = param.badge, qrCodeUrl = param.qrCodeUrl, qrCodeWidth = param.qrCodeContainerWidth, qrCodePadding = param.qrCodePadding, trackingFunctionOnHover = param.trackingFunctionOnHover;
    var _useState = _sliced_to_array(useState(false), 2), isMouseOver = _useState[0], setIsMouseOver = _useState[1];
    var showQRCode = useViewport().isTabletAndAbove && isMouseOver;
    var setIsMouseOverAndTrack = function() {
        setIsMouseOver(true);
        if (trackingFunctionOnHover) {
            trackingFunctionOnHover();
        }
    };
    return /*#__PURE__*/ _jsxs(Container, {
        $backgroundColor: backgroundColor,
        $showQRCode: showQRCode,
        onMouseOver: setIsMouseOverAndTrack,
        onMouseLeave: function() {
            return setIsMouseOver(false);
        },
        children: [
            badge,
            showQRCode ? /*#__PURE__*/ _jsx(QRCodeContainer, {
                $width: qrCodeWidth,
                $padding: qrCodePadding,
                children: /*#__PURE__*/ _jsx(AppsFlyerQRCode, {
                    qrCodeWidth: // container width minus padding on both sides
                    qrCodeWidth - 2 * qrCodePadding,
                    fallbackQrCodeUrl: qrCodeUrl
                })
            }) : null
        ]
    });
};
var Container = styled.div.withConfig({
    componentId: "sc-f273f0ae-0"
})([
    "",
    ""
], function(param) {
    var $showQRCode = param.$showQRCode, $backgroundColor = param.$backgroundColor;
    return $showQRCode ? css([
        "background:",
        ";border-radius:",
        ";"
    ], $backgroundColor, getSpacing("1x", "1x", 0, 0)) : "";
});
var QRCodeContainer = styled.div.withConfig({
    componentId: "sc-f273f0ae-1"
})([
    "",
    ""
], function(param) {
    var $width = param.$width, $padding = param.$padding;
    return css([
        "position:absolute;z-index:1;background-color:",
        ";width:",
        ";border-radius:",
        ";padding:",
        ";"
    ], Core.surface.default, getSpacing($width), getSpacing(0, 0, "1x", "1x"), getSpacing($padding));
});
